import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  ReferenceField,
  SingleFieldList,
  ChipField
} from "admin-on-rest";
import RelationsManyField from "../../../components/RelationsManyField";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import PromoFilter from "./PromoFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {refreshView as refreshViewAction} from "admin-on-rest";

class PromoDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: [],
    deleted: false
  };

  componentDidMount() {
    if (this.props.configuration && this.props.configuration.promos) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }
    this.setState({deleted: true});
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }
    if (this.props.record.list.ids !== nextProps.record.list.ids) {
      if (this.props.location.pathname === "/promos/") {
        this.setState({deleted: true});
      }
    }
  }

  componentWillUnmount() {
    this.setState({deleted: false});
  }

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.promos.name"
        {...props}
        actions={<ActionBar {...props} />}
        sort={{field: "first_name", order: "ASC"}}
        filters={<PromoFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <TextField label="resources.promos.fields.promoName" source="name" />
          <DateField
            label="resources.promos.fields.validFrom"
            source="valid_from"
          />
          <DateField
            label="resources.promos.fields.validTo"
            source="valid_to"
          />

          <RelationsManyField
            label="resources.promos.fields.industry"
            target="promo_id"
            source="industries_id"
            reference="industries"
            deleted={this.state.deleted}
          >
            <SingleFieldList>
              <ChipField source="name" />
            </SingleFieldList>
          </RelationsManyField>

          <ReferenceField
            label="resources.promos.fields.marketingPartner"
            source="marketing_partner_id"
            reference="marketing_partners"
            linkType={false}
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField
            label="resources.promos.fields.assignedStoresCount"
            source="assigned_stores_count"
          />

          <BooleanField
            elStyle={listStyle.booleanFieldStyle}
            label="resources.promos.fields.active"
            source="active"
          />
          <ActionMenu showButton={true} />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
    configuration: state.configuration
  };
};

const PromoDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(PromoDataListBase);

export default PromoDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/PromoDataList.js